module.exports = __webpack_public_path__ + "static/img/Red_Book.db491af1.png";